// src/pages/permissions/DepartmentList.js
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import {
  Box,
  Button,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AdminHeader from '../../components/AdminHeader';
import LayoutContainer from '../../components/LayoutContainer';
import departmentService from '../../services/departmentService';
import { filter, includes, isEmpty, join, map } from 'lodash';
import itemTypeService from '../../services/itemTypeService';

const DepartmentList = () => {
  const [departments, setDepartments] = useState([]);
  const [productTypesList, setproductTypesList] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchDepartment = async () => {
      const response = await departmentService.getDepartments();
      if (productTypesList) {
        setDepartments(
          map(response?.data, (item) => {
            return {
              ...item,
              item_type_id: item?.item_type_id
                ? map(
                    filter(productTypesList, (data) =>
                      includes(JSON?.parse(item?.item_type_id), data?.id)
                    ),
                    'type'
                  )
                : [],
            };
          })
        );
      }
    };
    fetchDepartment();
  }, [productTypesList]);

  const handleDelete = async (id) => {
    await departmentService.deleteDepartment(id);
    setDepartments(departments?.filter((department) => department?.id !== id));
  };

  const productTypes = async () => {
    const response = await itemTypeService.getItemTypes();
    setproductTypesList(response?.data);
  };

  const fetchProductTypes = async (array) => {
    const data = map(
      filter(productTypesList, (data) => includes(array, data?.id)),
      'type'
    );
    return data;
  };

  useEffect(() => {
    productTypes();
  }, []);

  return (
    <LayoutContainer>
      <AdminHeader title='Stations' />
      <div className='page-content-wrapper scrollable'>
        <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Button
            variant='contained'
            sx={{ backgroundColor: '#be210b', textTransform: 'none' }}
            onClick={() => navigate('/department/new')}
          >
            Add Station
          </Button>
        </Box>
        <Table className='table'>
          <TableHead className='tableHead'>
            <TableRow>
              <TableCell>Stations</TableCell>
              <TableCell>Type</TableCell>
              <TableCell>Product Types</TableCell>
              {/* <TableCell>Contact Name</TableCell> */}
              {/* <TableCell>Contact Number</TableCell> */}
              {/* <TableCell>Station Type</TableCell> */}
              <TableCell>Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody className='tableBody'>
            {departments.map((department, index) => (
              <TableRow
                key={department.id}
                sx={{
                  backgroundColor: index % 2 === 0 ? '#fff' : '#eaf3ff',
                  // '&:hover': { backgroundColor: '#e0f7fa' },
                }}
              >
                <TableCell>{department.name}</TableCell>
                <TableCell>{department.station_type || '-'}</TableCell>
                <TableCell>
                  {department?.item_type_id
                    ? isEmpty(department?.item_type_id)
                      ? '-'
                      : join(department?.item_type_id, ',')
                    : '-'}
                </TableCell>

                {/* <TableCell>{department.contact_name || '-'}</TableCell> */}
                {/* <TableCell>{department.contact_number || '-'}</TableCell> */}
                {/* <TableCell>{department.dept_type || '-'}</TableCell> */}
                <TableCell>
                  <IconButton
                    onClick={() =>
                      navigate(`/department/edit/${department.id}`)
                    }
                  >
                    <EditIcon sx={{ color: '#be210b' }} />
                  </IconButton>
                  {/* <IconButton onClick={() => handleDelete(department?.id)}>
                    <DeleteIcon sx={{ color: '#be210b' }} />
                  </IconButton> */}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </LayoutContainer>
  );
};

export default DepartmentList;
